import { apiCall } from './gqlClient';

const INGREDIENTS_QUERY = `
  query ingredients($providerId: Float, $search: String, $category: String, $allergenFree: String, $limit: JSON!, $language: String) {
    ingredients(providerId: $providerId, search: $search, category: $category, allergenFree: $allergenFree, limit: $limit, language: $language)
    {
      id
			providerId
			name
			localizedName
			category
			brand
			proteinsG
			fatsG
			carbohydratesG
			caloriesKcal
			fiberG
			sugarG
			glycemicIndex
			glycemicLoad
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			isSupplement
			isSportsDrink
			allergens
			sourceDb
      ...fragments
    }
  }`;

export const ingredientsApiCall = async ({providerId, search, category, allergenFree, limit, language}, fragments = null) => apiCall({ query: INGREDIENTS_QUERY, variables: {providerId, search, category, allergenFree, limit, language}, fragments });

const INGREDIENT_QUERY = `
  query ingredient($id: Float!, $language: String) {
    ingredient(id: $id, language: $language)
    {
      id
			providerId
			name
			localizedName
			category
			brand
			proteinsG
			fatsG
			carbohydratesG
			caloriesKcal
			fiberG
			sugarG
			glycemicIndex
			glycemicLoad
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			isSupplement
			isSportsDrink
			allergens
			sourceDb
      ...fragments
    }
  }`;

export const ingredientApiCall = async ({id, language}, fragments = null) => apiCall({ query: INGREDIENT_QUERY, variables: {id, language}, fragments });

const CREATEINGREDIENT_QUERY = `
  mutation createIngredient($input: IngredientInput!) {
    createIngredient(input: $input)
    {
      id
			providerId
			name
			localizedName
			category
			brand
			proteinsG
			fatsG
			carbohydratesG
			caloriesKcal
			fiberG
			sugarG
			glycemicIndex
			glycemicLoad
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			isSupplement
			isSportsDrink
			allergens
			sourceDb
      ...fragments
    }
  }`;

export const createIngredientApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEINGREDIENT_QUERY, variables: {input}, fragments });

const UPDATEINGREDIENT_QUERY = `
  mutation updateIngredient($id: Float!, $input: IngredientInput!) {
    updateIngredient(id: $id, input: $input)
    {
      id
			providerId
			name
			localizedName
			category
			brand
			proteinsG
			fatsG
			carbohydratesG
			caloriesKcal
			fiberG
			sugarG
			glycemicIndex
			glycemicLoad
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			isSupplement
			isSportsDrink
			allergens
			sourceDb
      ...fragments
    }
  }`;

export const updateIngredientApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEINGREDIENT_QUERY, variables: {id, input}, fragments });

const DELETEINGREDIENT_QUERY = `
  mutation deleteIngredient($id: Float!) {
    deleteIngredient(id: $id)
    {
      id
			providerId
			name
			localizedName
			category
			brand
			proteinsG
			fatsG
			carbohydratesG
			caloriesKcal
			fiberG
			sugarG
			glycemicIndex
			glycemicLoad
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			isSupplement
			isSportsDrink
			allergens
			sourceDb
      ...fragments
    }
  }`;

export const deleteIngredientApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEINGREDIENT_QUERY, variables: {id}, fragments });
